import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ListHeaderContainer,
  PaginationContainer,
  TableContainer,
} from "../../../../containers";
import { filterObjectKeys } from "../../../../helpers";
import { getListReservation } from "../../../../store/reservation";
import { LoadingComponent } from "../../../../components";

const URL = "configuracion/landing/reservaciones";
const dataInput = {
  id: "searchReservation",
  placeholder: "Buscar reservación",
};
const allowedKeys = [
  "id",
  "name",
  "email",
  "document",
  "phone",
  "state",
  "date",
  "created",
  "time",
  "numberPerson",
  "reservationReason",
  "shop",
  "description",
];
const dataHeader = {
  title: "Reservaciones",
  nameButton: "Crear Reservación",
  url: "",
};

export const SettingLandingReservationIndexPage = () => {
  const { reservationData, showLoading } = useSelector(
    (state) => state.listReservation
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();
  const serachParams = new URLSearchParams(search);
  const pageReservation = serachParams.get("page");
  const searchReservation = serachParams.get("search");

  let reservationParams = {
    page_size: 20,
    page: pageReservation ?? 1,
    search: searchReservation ?? "",
  };

  useEffect(() => {
    dispatch(getListReservation(reservationParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageReservation, searchReservation]);

  const filter = () => {
    const searchValue = document.getElementById("searchReservation").value;
    if (searchValue === "") {
      dispatch(getListReservation());
      navigate("/" + URL);
      return;
    }
    const searchUrl = `/configuracion/landing/reservaciones?search=${searchValue}`;

    navigate(searchUrl);
  };

  const handleKeyDown = (e) => {
    const searchValue = document.getElementById("searchReservation").value;
    if (e.key === "Backspace" && searchValue.length === 1) {
      dispatch(getListReservation());
      navigate("/" + URL);
    }
    if (e.key !== "Enter") return;
    filter();
  };

  const getUrl = (id) => {
    return `/configuracion/landing/reservaciones/${id}/detalles`;
  };

  const newData = reservationData?.results?.map((obj) =>
    filterObjectKeys(obj, allowedKeys)
  );
  return (
    <section className="clientIndexPage">
      <ListHeaderContainer data={dataHeader} addButton={false} />
      {!showLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <TableContainer
            filter={filter}
            handleKeyDown={handleKeyDown}
            dataInput={dataInput}
            data={newData}
            url={getUrl}
            titles={allowedKeys}
            isFilter={false}
          />
          <PaginationContainer data={reservationData} />
        </>
      )}
    </section>
  );
};
